export default __webpack_public_path__ + "static/media/tools-dashboard.de74cca9.svg";